import {
  ResourcePointManagementFeaturePage,
  type ResourcePointListScope,
} from "..";

type ResourcePointManagementPageProps = {
  scope?: ResourcePointListScope;
};

/** 考察点管理路由页稳定入口。 */
export function ResourcePointManagementPage({
  scope = "all",
}: ResourcePointManagementPageProps) {
  return <ResourcePointManagementFeaturePage key={scope} scope={scope} />;
}
